<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { AccordionContent, type AccordionContentProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<AccordionContentProps & { class?: HTMLAttributes["class"] }>()

const className = useClass(
	"pb-4 pt-0",
	() => rawClass,
)
</script>

<template>
	<AccordionContent
		v-bind="props"
		class="overflow-hidden text-sm data-[state=open]:accordion-down data-[state=closed]:accordion-up">
		<div :class="className">
			<slot />
		</div>
	</AccordionContent>
</template>
